if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

(function () {
  function mountToBody() {
  const mount = document.getElementById('SizeChartMount');
  if (mount && mount.parentElement !== document.body) {
    document.body.appendChild(mount);
  }

  // Overlay click handler (1x)
  const overlayEl = document.querySelector('[data-sizechart-overlay]');
  if (overlayEl && !overlayEl.dataset.bound) {
    overlayEl.addEventListener('click', closeDrawer);
    overlayEl.dataset.bound = "true";
  }
}


  function getEls() {
    return {
      openBtn: document.querySelector('[data-sizechart-open]'),
      drawer: document.getElementById('SizeChartDrawer'),
      overlay: document.querySelector('[data-sizechart-overlay]'),
      closeBtn: document.querySelector('[data-sizechart-close]')
    };
  }

  function openDrawer(e){
    e.preventDefault();
    const { openBtn, drawer, overlay, closeBtn } = getEls();
    if (!drawer || !overlay) return;

    document.body.classList.add('sizechart-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer(){
    const { openBtn, drawer, overlay } = getEls();
    if (!drawer || !overlay) return;

    document.body.classList.remove('sizechart-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (openBtn) openBtn.focus();
  }

  document.addEventListener('DOMContentLoaded', mountToBody);
  window.addEventListener('load', mountToBody);

  document.addEventListener('click', function(e){
  const open = e.target.closest('[data-sizechart-open]');
  const closeBtn = e.target.closest('[data-sizechart-close]');
  const overlay = e.target.closest('[data-sizechart-overlay]');
  const drawer = e.target.closest('#SizeChartDrawer');

  if (open) {
    e.preventDefault();
    return openDrawer(e);
  }

  // Sluiten via close knop
  if (closeBtn) {
    return closeDrawer();
  }

  // Sluiten via overlay (maar NIET als je in de sidebar klikt)
  if (overlay && !drawer) {
    return closeDrawer();
  }
});


  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.classList.contains('sizechart-open')) closeDrawer();
  });
})();
